<script setup lang="ts">
</script>
<template>
  <div class="flex items-center gap-[15px]">
    <div class="w-15">
      <UiIcon name="sale-label-pdp" class="size-15" />
    </div>
    <p class="text-[13px] capitalize">
      <span class="font-bold italic">{{ $t("finalSaleText") }}</span>&nbsp;
      <span class="font-light not-italic underline">
        {{ $t("nonRefundable") }}
      </span>
    </p>
  </div>
</template>
